import { render, staticRenderFns } from "./AssignDisabilities.vue?vue&type=template&id=59714f0a&"
import script from "./AssignDisabilities.vue?vue&type=script&lang=js&"
export * from "./AssignDisabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports